import React from 'react';
import { CategoriesProgressStyled } from './styles';

interface MedicalCategoryProgressProps {
  progressText: string;
}

export const MedicalCategoryProgress: React.FC<MedicalCategoryProgressProps> = ({ progressText }) => {
  return <CategoriesProgressStyled>{progressText}</CategoriesProgressStyled>;
};
